import { Button } from '@/components';
import { Tip } from '@/components/Tip/Index';
import React, { FormEvent } from 'react';

interface ForgotPasswordContentProps {
  state: boolean;
  onSubmit: (e: FormEvent) => void;
}

export const ForgotPasswordBiometricContent: React.FC<ForgotPasswordContentProps> = ({
  state,
  onSubmit,
}) => (
  <div className="mt-5 w-full">
    <form onSubmit={onSubmit}>
      <p className="mb-6 text-neutro-b-400 text-[21px] font-dmsans font-normal w-4/5">
        Para continuar, será iniciado o processo de <strong>verificação facial</strong> com uso da
        câmera. Siga as instruções:
      </p>

      <div className="mt-4 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Tip
          icon="💡"
          title="Boa iluminação"
          text="Fique de frente para a luz (evite luz atrás de você)."
        />
        <Tip icon="🧢" title="Sem acessórios" text="Remova boné, óculos escuros e máscaras." />
        <Tip
          icon="📱"
          title="Enquadre o rosto"
          text="Centralize o rosto e mantenha o celular na altura dos olhos."
        />
        <Tip icon="🧍" title="Fundo neutro" text="Prefira um fundo liso e sem estampas." />
        <Tip
          icon="🎥"
          title="Movimentos"
          text="Siga os movimentos solicitados (ex.: olhar para os lados)."
        />
        <Tip icon="🔇" title="Ambiente calmo" text="Evite tremer; segure firme o aparelho." />
      </div>

      <Button
        type="submit"
        title="Iniciar Verificação Facial"
        buttonStyle="primary"
        size="xlg"
        className="w-full mt-8"
        disabled={state}
      />
    </form>
  </div>
);
